<!--
<ion-row class="dashboard-row">
  
  <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/contracts')">
    <div class="dash-widget">
      <div class="dash-widget-icon">
        <span class="custom-icon-dashboard-invoice-icons"></span>
      </div>
      <div class="dash-widget-info">
        <h4 class="dash-amount">{{ contractsCount }}</h4>
        <p class="dash-text">I miei investimenti</p>
      </div>
    </div>
  </ion-col>
  <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/news')">
    <div class="dash-widget">
      <div class="dash-widget-icon">
        <span class="custom-icon-dashboard-client-icon"></span>
      </div>
      <div class="dash-widget-info">
        <h4 class="dash-amount"></h4>
        <p class="dash-text">News</p>
      </div>
    </div>
  </ion-col>
  
  <ion-col size="6" [ngClass]="cssClass" class="dashboard-col" (click)="openPage('/products')">
    <div class="dash-widget">
      <div class="dash-widget-icon">
        <span class="custom-icon-dashboard-employee-icons"></span>
      </div>
      <div class="dash-widget-info">
        <h4 class="dash-amount">{{ productsCount }}</h4>
        <p class="dash-text">I nostri prodotti</p>
      </div>
    </div>
  </ion-col>

</ion-row>-->
<div class="menu-grid-container">
  <div
          class="glass-blurred-background menu-box center-content"
          (click)="openPage('/my-investments')"
  >
    <img class="block-image svg-white" src="./assets/imgs/investimenti.svg" />
    <h2 class="text-center">
      MIEI <br />
      <div class="wrap-text">INVESTIMENTI</div>
    </h2>
  </div>
  <div
          class="glass-blurred-background menu-box center-content"
          (click)="openPage('/news')"
  >
    <img class="block-image svg-white" src="./assets/imgs/news.svg" />
    <h2 class="text-center">NEWS</h2>
  </div>

  <div
          class="glass-blurred-background menu-box center-content"
          (click)="openPage('/products')"
  >
    <img class="block-image svg-white" src="./assets/imgs/prodotti.svg" />
    <h2 class="text-center">
      PRODOTTI <br />
      <div class="wrap-text">AZIENDALI</div>
    </h2>
  </div>
</div>
